import type { Abi, Address, Hash } from 'viem'
import type { Connector } from 'wagmi'

import { beginWalletSigning, endWalletSigning, type WalletWriteProgressPhase } from './walletSigningFlow'
import { submitContractWrite } from './submitContractWrite'

export type SimulatedContractRequest = {
  address: Hash
  abi: Abi
  functionName: string
  args: readonly unknown[]
}

export async function submitSimulatedContractWrite(params: {
  request: SimulatedContractRequest
  account: Address
  chainId: number
  connector: Connector
  gas?: bigint
  value?: bigint
  onPhase?: (phase: WalletWriteProgressPhase) => void
}): Promise<Hash> {
  beginWalletSigning()
  params.onPhase?.('wallet')
  try {
    const hash = await submitContractWrite({
      address: params.request.address,
      abi: params.request.abi,
      functionName: params.request.functionName,
      args: params.request.args,
      account: params.account,
      chainId: params.chainId,
      connector: params.connector,
      gas: params.gas,
      value: params.value,
    })
    params.onPhase?.('submitted')
    endWalletSigning()
    return hash
  } catch (error) {
    endWalletSigning()
    throw error
  }
}
